import { useEffect} from 'react';
import useGetNewestSearch from '../../hooks/useGetNewestSearch';
import { Clock} from 'react-feather';
import { POLICY_EMPTY_FILTERED_TAGS } from '@constants';
import { shouldShowLoginUI } from '@utils/authUtils';
import util from '../../../../utils/utils';

// 处理长文本省略的函数
const truncateText = (text, maxLength = 20) => {
    if (!text || text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
};

export const SearchHistoryDiv = (props) => {
    const {setSearchK, setQuery, setCurrentSection} = props
    const {newestSearchLoading, newestSearchData} = useGetNewestSearch();
    
    // ✅ 添加详细调试信息
    const clientId = util.getCurrentClientId();
    const isUserLoggedIn = util.isUserLoggedIn();
    const shouldShow = shouldShowLoginUI();
    
    // ✅ 使用统一的显示逻辑
    if (!shouldShow) {
        return null;
    }


    return (
        <>
            <div className='flex flex-wrap gap-2 px-4 pt-0 lg:mb-0 mb-16 pb-2 items-center justify-center min-h-16'>
                <Clock size="16"/>搜索记录 : 
                {
                    newestSearchLoading ? 
                    <>
                        <span className="skeleton h-6 w-16"></span>
                        <span className="skeleton h-6 w-16"></span>
                        <span className="skeleton h-6 w-16"></span>
                    </> :
                    <>
                        {
                            newestSearchData && newestSearchData?.length > 0 ? 
                            newestSearchData?.map((item, index) => <button key={index} className="btn text-lg btn-link"
                                onClick={()=>{
                                    setSearchK(item?.search_content);
                                    // 点击搜索历史时设置默认机构筛选条件
                                    if(setQuery){
                                        setQuery({
                                            filter_tags: POLICY_EMPTY_FILTERED_TAGS,
                                            state_grid_related: false
                                        })
                                    }
                                    if(setCurrentSection){
                                        setCurrentSection('main')
                                    }
                                }}
                                title={item?.search_content} // 添加完整的文本作为tooltip
                            >
                                {truncateText(item?.search_content)}
                            </button>) :
                            <span className="text-gray-500">暂无搜索记录</span>
                        }
                    </>
                }
            </div>
        </>
    )
}